module.exports = __webpack_public_path__ + "static/media/herz.84984832.png";